import type { GirderModel, GirderModelType } from '@girder/components/src';
import type { BrandData } from 'platform/web-girder/api';
import type { GirderConfig } from 'platform/web-girder/constants';

/**
 * Location can be either
 *  a proper girder model,
 *  a root virtual model,
 *  or a simplified id/type pair.
 * These types are mutually exclusive.
 */
export type RootlessLocationType = GirderModel | { '_id': string; '_modelType': GirderModelType };
export type LocationType = RootlessLocationType | { type: 'collections' | 'users' | 'root' };
export interface LocationState {
  location: LocationType | null;
  selected: GirderModel[];
}

export interface DatasetState {
  meta: GirderConfig | null;
}

export interface BrandState {
  brandData: BrandData;
}

export interface UserState {
  user: null | {
    admin: boolean;
    email: string;
    firstName: string;
    login: string;
    lastName: string;
    status: string;
  };
}
export interface JobState {
  jobIds: Record<string, number>;
  datasetStatus: Record<string, { status: number; jobId: string }>;
  /** All jobs attributed to a dataset id (parent-scoped convert/split/finalize). */
  datasetJobs: Record<string, Record<string, number>>;
  completeJobsInfo: Record<string, { type: string; title: string; success: boolean }>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isGirderModel(value: any): value is GirderModel {
  return value._id && value._modelType;
}
